import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

interface DialogData {
  studentId: number;
  studentName: string;
  placementId: number;
  clientId: number;
}

@Component({
    templateUrl: 'select-timeline-subject-modal.component.html',
    selector: 'select-timeline-subject-modal',
    styleUrls: ['./select-timeline-subject-modal.component.css'],
    standalone: false
})
export class SelectTimelineSubjectModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<SelectTimelineSubjectModalComponent>  ) {

  }

  public close() {
    this.dialogRef.close();
  }
}
